/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const HeaderActions = styled.div(
  {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  ({ includeDiffActions }: { includeDiffActions?: boolean }) => ({
    marginTop: !includeDiffActions
      ? token('space.0', '0px')
      : token('space.negative.200', '-16px'),
  })
);

export const DropdownMenu = styled.div({
  textAlign: 'initial',
});

export const DropdownMenuContent = styled.div({
  minWidth: '162px',
});

export const HeaderActionsButtonWrapper = styled.div({
  marginTop: token('space.200', '16px'),
});

export const WhiteBackgroundWrapper = styled.div({
  background: token('elevation.surface', colors.N0),
});
